export const pinLogin = {
  "title": "Enter PIN",
  "checkingPin": "Checking PIN...",
  "adminLoginLink": "Switch to Admin Login"
};
